module.exports = __webpack_public_path__ + "src/assets/img/photo_amerisolar2.e26ad66a.jpg";